import routesPath from "./routesPath";

const common = {
  benefit: {
    tier: 1,
    single: 2,
    unique: 3,
  },
  tierCodeId: {
    memberOnly: 1,
  },
  serviceType: {
    Cobra: 0,
    Open: 1,
  },
  pageStep: {
    enrollments: 1,
    profileInformation: 2,
    dependents: 3,
    benefits: 4,
    documents: 5,
    confirmation: 6,
    payments: 7,
    cardDetails: 8,
  },
  paymentMethods: {
    ACH: 1,
    Invoice: 2,
    Card: 3,
  },
  allRoutes: [
    {
      link: routesPath.profileInformation,
      priority: 1,
    },
    {
      link: routesPath.dependents,
      priority: 2,
    },
    {
      link: routesPath.benefits,
      priority: 3,
    },
    {
      link: routesPath.documents,
      priority: 4,
    },
    {
      link: routesPath.confirmation,
      priority: 5,
    },
    {
      link: routesPath.payments,
      priority: 6,
    },
    {
      link: routesPath.cardDetails,
      priority: 7,
    },
  ],
  dependentRelations: {
    spouse: "Spouse",
    son: "Son",
    daughter: "Daughter",
  },
  dependentRelationsId: {
    spouse: 1,
  },
  timezone: {
    ET: "ET",
  },
  otpTimer: "59",
  logoutCountDown: 120,
  logoutModalInterval: 30,
  statusCode: {
    notFound: 404,
  },
  saveNext: "SAVE & NEXT",
  skipNext: "SKIP & NEXT",
  storageVariables: {
    currentRoute: "current_route",
    allBenefitsWaived: "allBenefitsWaived",
    isSubmitted: "isSubmitted",
    pageStep: "pageStep",
    loginData: "loginData",
    accessToken: "access_token",
    accessTokenExpiry: "access_token_expiry",
    applicationSubmitted: "applicationSubmitted",
    otpTimer: "otpTimer",
    paymentMethod: "paymentMethod",
    challengeQuestion: "challengeQuestion",
    emailAddress: "emailAddress",
    enrollments: "enrollments",
    customerParticipantId: "customerParticipantId",
    enrollmentType: "enrollmentType",
    mfaToken: "MFAToken",
    enrollment: "enrollment",
    formDirty: "formDirty",
    showModal: "showModal",
    logoutModal: "logoutModal",
    logoutTimer: "logoutTimer",
    clearTheInterval: "clearTheInterval",
    modalTitle: "modalTitle",
    modalContent: "modalContent",
    uploadFiles: "uploadFiles",
    uploadProgress: "uploadProgress",
    uploadedFiles: "uploadedFiles",
    totalFiles: "totalFiles",
    cancelTokenSource: "cancelTokenSource",
    documentSubmitBtn: "documentSubmitBtn",
    benefitAmount: "benefitAmount",
    autoLogoutMsg: "autoLogoutMsg",
    documentsUploaded: "documentsUploaded",
    benefitRates: "benefitRates",
    benefits: "benefits",
    dependents: "dependents",
    validationMsg: "validationMsg",
    calculateRates: "calculateRates",
    totalEnrollments: "totalEnrollments",
    wasSpecialOpenEnrollmentCreated: "wasSpecialOpenEnrollmentCreated",
    maskedEmailAddress: "maskedEmailAddress",
    isPayed: "isPayed",
    paymentIntents: "paymentIntents",
    settings: "settings"
  },
};

export default common;
